import script from "./Download.vue?vue&type=script&setup=true&lang=js"
export * from "./Download.vue?vue&type=script&setup=true&lang=js"

import "./Download.vue?vue&type=style&index=0&id=346a5dc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-346a5dc3"]])

export default __exports__